import { TokenService } from '../../services/authentication/token.service';
import { PermissionStore } from '../../stores/permission-store';
import { FeatureFlagsManager } from '../../utils/core/feature-flags-manager';
import { LocalStorageHandler } from '../../utils/core/local-storage-handler';
import { useAuthState } from '../state/auth-state';
import { useOptionalUserState } from '../state/user-state/user-state';

const useAuth = () => {
  const { refreshUser } = useAuthState();
  const userState = useOptionalUserState();
  const setActiveRole = userState?.setActiveRole ?? (() => undefined);

  return {
    /**
     * Saves token to local storage. Also extracts email from token and stores this in local
     * storage. Also handles some other things required when user logs in.
     */
    saveToken: async (token: string) => {
      const tokenService = new TokenService();
      const extractedToken = tokenService.decodeToken(token);

      if (extractedToken) {
        const email: string = extractedToken.userEmail;

        tokenService.set(token);
        LocalStorageHandler.instance.setValue('userEmail', email);
      } else {
        tokenService.remove();
      }

      setActiveRole(null);
      await refreshUser();

      // Temporary solution to have the permissions loaded when a user signs in or refreshes the page.
      // With React the whole authentication process will be rewritten.
      if (FeatureFlagsManager.instance.isEnabled('SK-4477-access-management')) {
        await PermissionStore.instance.refreshAccessState();
      }
    },
  };
};

export const authHook = {
  useAuth,
};
